import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { HeadToHeadQueryContext } from '../head-to-head-query-context';
import { AlertService } from '../../shared/alert/alert.service';
import { JhiEventManager } from '../../shared/core-utils';
import { HeadToHeadQueryService } from '../head-to-head-query.service';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';
import { GermplasmPairTraitModel } from '../model/germplasm-pair-trait.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Environment, VariableResultsRequestModel } from '../model/variable-results-request.model';
import { FileDownloadHelper } from '../../entities/sample/file-download.helper';

@Component({
    selector: 'jhi-display-results',
    styleUrl: './display-results.component.scss',
    templateUrl: './display-results.component.html'
})
export class DisplayResultsComponent implements OnInit, OnDestroy {

    private subscriptionsManager: SubscriptionsManager = new SubscriptionsManager();
    @Output() back = new EventEmitter<void>();
    @Input() active = false;
    selectedTraitModels: GermplasmPairTraitModel[] = [];
    isLoading = false;

    constructor(public queryContext: HeadToHeadQueryContext,
                public alertService: AlertService,
                private eventManager: JhiEventManager,
                private headToHeadQueryService: HeadToHeadQueryService,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private fileDownloadHelper: FileDownloadHelper) {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['active'] && this.active) {
            if (this.queryContext.traits && this.queryContext.traits.length) {
                this.selectedTraitModels = this.queryContext.traits;
                this.navigateToFirstTab();
            }
        }
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    prevStep(): void {
        this.back.emit();
    }

    export($event) {
        $event.preventDefault();
        const isGermplasmListUpdateFormat = true;
        const variableResultsRequest = new VariableResultsRequestModel();
        variableResultsRequest.germplasmPairs = this.queryContext.germplasmPairs;
        variableResultsRequest.traits = this.queryContext.traits;
        variableResultsRequest.environments = Array.from(this.queryContext.environments).map(env => new Environment(env.id, env.weight));
        this.isLoading = true;
        this.subscriptionsManager.add = this.headToHeadQueryService.exportResults(variableResultsRequest).subscribe((response) => {
            this.isLoading = false;
            const fileName = this.fileDownloadHelper.getFileNameFromResponseContentDisposition(response);
            this.fileDownloadHelper.save(response.body, fileName);
        });
    }

    private navigateToFirstTab() {
        const firstVariableId = this.selectedTraitModels[0].variableId;
        this.router.navigate([
            { outlets: { 'display-result-outlet': 'variableId/' + firstVariableId } }
        ], {
            relativeTo: this.activatedRoute,
            queryParamsHandling: 'merge'
        });
    }
}
